import React from 'react';
import 'tailwindcss/tailwind.css';
import { Divider } from '@mui/material';

const ShowsEnVivo = () => {
  return (
    <>
      <HeroSection />
      <UpcomingLivestreamsSection />
      <PastLivestreamsSection />
    </>
  );
};

const HeroSection = () => {
  return (
    <section className="relative py-16 md:py-24 w-full h-[50vh] min-h-[400px] overflow-hidden">
      {/* Imagen de fondo provisional */}
      <div className="absolute inset-0">
        <img 
          src="https://radhotelgroup.com/wp-content/uploads/2019/11/Radstone-Comedy-Night-Tiles-1920x800.jpg" 
          alt="Comedy Livestream Background" 
          className="w-full h-full object-cover opacity-60" 
        />
        {/* Overlay para mejorar legibilidad del texto */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>
      </div>
      
      <div className="relative z-10 container mx-auto px-4 h-full flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">Livestreams</h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
            Disfruta de los mejores shows de comedia en vivo desde cualquier lugar
          </p>
        </div>
      </div>
    </section>
  );
};

const UpcomingLivestreamsSection = () => {
  const upcomingStreams = [
    {
      id: 1,
      title: "Humor Santiaguino",
      comedian: "Felipe Arévalo",
      date: "28 Mayo 2025",
      time: "20:00",
      platform: "Stupid Comedy App",
      location: "Santiago, Chile",
      image: "https://scontent.flsc3-1.fna.fbcdn.net/v/t39.30808-6/432930460_10232505534846751_6901105742368944987_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeHCp3vuwc5uRKyqe1Is_bdVS5naRgRVKzBLmdpGBFUrMLglip0AP9xF7LHo1lt6ptTQKf9XzCGot6g4ZSy-Z5g7&_nc_ohc=LgMV6xO0-roQ7kNvwHS8EN_&_nc_oc=AdkRtUiMF8sl1IEVl3ZrqAHvahDmQiu4SBvMA7HfL6OAVXMg6yG3RzbAzXPEUc1-Uz0&_nc_zt=23&_nc_ht=scontent.flsc3-1.fna&_nc_gid=VZwb360iWTQdkp0oFRKCAQ&oh=00_AfF7yqfiIxJ-P0Evm4Yixgp0qQ22cKYkm1TQPoLUE70xfg&oe=680DCA3F",
      price: "$7.500",
      tags: ["Stand-up", "Humor Local"]
    },
    {
      id: 2,
      title: "Noche de Improvisación",
      comedian: "Carolina Valenzuela",
      date: "5 Junio 2025",
      time: "21:30",
      platform: "Stupid Comedy App",
      location: "Ñuñoa, Santiago",
      image: "https://standupclubarg.com/wp-content/uploads/2024/12/que-se-hace-en-un-stand-up.webp",
      price: "$5.900",
      tags: ["Improvisación", "Comedia"]
    },
    {
      id: 3,
      title: "Risas del Mapocho",
      comedian: "Manuel Fuentes",
      date: "12 Junio 2025",
      time: "20:30",
      platform: "Stupid Comedy App",
      location: "Providencia, Santiago",
      image: "https://standupclubarg.com/wp-content/uploads/2025/02/Que-es-un-evento-de-stand-up.webp",
      price: "$6.500",
      tags: ["Stand-up", "Sátira Política"]
    }
  ];

  return (
    <section className="py-16 bg-black text-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold mb-12 text-center">Próximos Livestreams</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {upcomingStreams.map((stream) => (
            <StreamCard key={stream.id} stream={stream} />
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <button className="bg-red-600 hover:bg-red-700 transition-all duration-300 text-white py-3 px-8 rounded-lg text-xl font-medium transform hover:scale-105 shadow-lg hover:shadow-red-500/50">
            Ver todos los livestreams
          </button>
        </div>
      </div>
    </section>
  );
};

const StreamCard = ({ stream }) => {
  return (
    <div className="bg-zinc-900 rounded-xl overflow-hidden transition-all duration-300 transform hover:-translate-y-2 hover:shadow-xl">
      <div className="relative h-64">
        <img src={stream.image} alt={stream.title} className="w-full h-full object-cover" />
        <div className="absolute top-0 right-0 bg-red-600 px-3 py-1 m-3 rounded-full text-sm font-medium">
          EN VIVO
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-4">
          <h3 className="text-2xl font-bold">{stream.title}</h3>
          <p className="text-xl text-white/90">{stream.comedian}</p>
        </div>
      </div>
      
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <div>
            <p className="text-lg font-semibold">{stream.date}</p>
            <p className="text-white/80">{stream.time} hrs.</p>
          </div>
          <p className="text-lg font-bold text-red-500">{stream.price}</p>
        </div>
        
        <div className="mb-4">
          <p className="font-medium">{stream.platform}</p>
          <p className="text-white/80">{stream.location}</p>
        </div>
        
        <div className="flex flex-wrap gap-2 mb-5">
          {stream.tags.map((tag, index) => (
            <span 
              key={index} 
              className="bg-purple-700/50 rounded-full px-3 py-1 text-sm"
            >
              {tag}
            </span>
          ))}
        </div>
        
        <button className="w-full bg-red-600 hover:bg-red-700 transition-all duration-300 text-white py-2 rounded-lg font-medium">
          Reservar acceso
        </button>
      </div>
    </div>
  );
};

const PastLivestreamsSection = () => {
  const pastStreams = [
    {
      id: 4,
      title: "Humor Chileno Sin Filtro",
      comedian: "Javiera Contreras",
      image: "https://standupclubarg.com/wp-content/uploads/2025/02/Espectaculo-de-humor-para-cumpleanos.webp",
      views: "12.458"
    },
    {
      id: 5,
      title: "Historias de Las Condes",
      comedian: "Rodrigo Vásquez",
      image: "https://aprendestandup.com.ar/wp-content/uploads/2024/07/presentador_standup.jpg",
      views: "8.932"
    },
    {
      id: 6,
      title: "Noche de Stand-up Santiago",
      comedian: "Camila Durán",
      image: "https://i0.wp.com/www.enlacejudio.com/wp-content/uploads/2022/02/stand-up-real_opt.jpg?w=700&ssl=1%20700w",
      views: "15.723"
    }
  ];

  return (
    <section className="py-16 bg-zinc-950 text-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold mb-6 text-center">Livestreams Anteriores</h2>
        <p className="text-center text-white/80 mb-12 max-w-2xl mx-auto">
          Revive los mejores momentos de nuestros shows en línea anteriores, disponibles para suscriptores premium
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pastStreams.map((stream) => (
            <div 
              key={stream.id} 
              className="relative h-64 rounded-xl overflow-hidden group cursor-pointer"
            >
              <img 
                src={stream.image} 
                alt={stream.title} 
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-4">
                <p className="text-sm text-white/70">{stream.views} visualizaciones</p>
              </div>
              <div className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="text-center">
                  <h3 className="text-xl font-bold">{stream.title}</h3>
                  <p className="text-white/90">{stream.comedian}</p>
                  <button className="mt-4 bg-red-600 hover:bg-red-700 transition-all duration-300 text-white py-2 px-4 rounded-lg font-medium">
                    Ver grabación
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShowsEnVivo;